import { Box, Card } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import { SibaGridColumn, DefaultGrid, ErrorBoundary } from "@siba/components";
import { guidUtil } from "@siba/utilities";
import { lazy } from "react";

const SibaExcelUpload = lazy(() => import("../SibaExcelUpload"));

/***
 * @interface SearchGridProps defines the properties of search grid component.
 */
interface SearchGridProps<T> {
    /**
     * Grid data instance
     */
    data: T[];
    /**
     * Callback function for on select
     */
    handleSelect: Dispatch<SetStateAction<T>>;
    /**
     * Callback function for on double click
     */
    handleDoubleClick: any;

    columnDefinition?: SibaGridColumn[];

    height?: string | number;

    editable?: boolean;

    rowDataBound?: any;

    saveUploadMethod?: any;
}

/**
 * The  search grid function
 * @param props Search Grid Propertperties form @interface SearchGridProps
 * @returns Jsx component.
 */
export const SearchGrid = (props: SearchGridProps<any>) => {
    const { data, handleSelect, handleDoubleClick, columnDefinition, height, editable, rowDataBound, saveUploadMethod } = props;
    const [gridID] = useState(guidUtil.getGuid());
    return (
        <Box mb={2} style={{ width: "100%", overflowX: "auto" }}>
            <p className="card-description"></p>
            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                <Card variant="elevation">
                    {saveUploadMethod && (
                        <ErrorBoundary>
                            <SibaExcelUpload columnDefinitions={columnDefinition || []} loadMethod={saveUploadMethod} />
                        </ErrorBoundary>
                    )}
                    <ErrorBoundary>
                        <DefaultGrid
                            id={gridID}
                            data={data}
                            columns={columnDefinition}
                            onRowClick={(e) => {
                                handleSelect(e.row as any);
                            }}
                            onDoubleClick={(e) => {
                                handleDoubleClick(e.row as any);
                            }}
                            height={height}
                            editable={editable}
                            rowDataBound={rowDataBound}
                        />
                    </ErrorBoundary>
                </Card>
            </Box>
        </Box>
    );
};
